// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../procollege/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../procollege/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folder:hover{opacity:50%}`, "",{"version":3,"sources":["webpack://./../blocks/manage_groups/documents3/styles.css"],"names":[],"mappings":"AAAA,cACI,WAAA","sourcesContent":[".folder:hover{\r\n    opacity: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
